var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(_vm.logPatientLists)?_c('LogTemplate',{attrs:{"job":_vm.logPatientLists.job,"patient":_vm.logPatientLists,"detail":_vm.logPatientLists,"schedules":_vm.logPatientLists.schedules}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }